// extracted by mini-css-extract-plugin
export default {"container":"DefaultPageLayout_container__usLmh","content":"DefaultPageLayout_content__ChTVd"};